import React, { useState, useEffect, useMemo } from 'react';

import cn from 'classnames';
import { connectMenu } from 'react-instantsearch-dom';

import { lettersArray } from './const';
import useStyles from './styles';

const IndexMenu = ({ items, refine }) => {
  const classes = useStyles();

  const [hasRefined, setHasRefined] = useState(false);
  const normalizedItems = useMemo(() => {
    const obj = {};
    items.forEach((item) => {
      obj[item.label] = item;
    });

    return obj;
  }, [items]);

  useEffect(() => {
    setHasRefined(!!items.filter((item) => item.isRefined).length);
  }, [items]);

  return (
    <div className={classes.wrapper}>
      <div
        key="all"
        className={cn(classes.index, !hasRefined && classes.active)}
        onClick={() => refine('')}
      >
        All
      </div>
      {lettersArray.map((item) => {
        const exists = item in normalizedItems;
        return (
          <div
            key={item}
            className={cn(
              classes.index,
              exists ? normalizedItems[item].isRefined && classes.active : classes.disabled,
            )}
            onClick={exists ? () => refine(normalizedItems[item].value) : () => {}}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

export default connectMenu(IndexMenu);
